// Spanish translation

const es = {
  "menu.company_integration_financial": "Integración Financiera",
};

export default es;
